/**
 * Keep the working set small so seeking and audio changes do not queue dozens
 * of obsolete segment requests, especially on TVs and multi-audio titles.
 */
export const HLS_BUFFER_CONFIG = Object.freeze({
  backBufferLength: 12,
  maxBufferLength: 12,
  maxMaxBufferLength: 12,
  maxBufferSize: 24 * 1024 * 1024,
  maxBufferHole: 0.1,
});
